<template>
  <DepartmentFacts
    :heading="data.heading || ''"
    :updated-at="data.updatedAt || ''"
    :cards="data.cards || []"
    :disclaimer="data.disclaimer || ''"
  />
</template>

<script>
import DepartmentFacts from '@/components/Departments/DepartmentFacts.vue';

export default {
  name: 'AppDepartmentFactsBlock',
  components: { DepartmentFacts },
  props: {
    data: { type: Object, default: () => ({}) },
  },
};
</script>
